import { Badge } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Icon from '@material-ui/core/Icon';
import { MuiThemeProvider } from '@material-ui/core/styles';
import { getButtonTheme } from '../../config/MaterialTheme';
import { getMergedClassNames } from '../../utils/HTMLUtils';
import styles from './CustomButton.scss';
import { useCallback } from 'react';

const rootClassName = styles.rootClassName;

const CustomButton = (props) => {
  const toClick = () => {
    if (typeof props.onClick === 'function') {
      props.onClick();
    }
  };

  const getIcon = useCallback((isLeft, icon) => {
    const direction = isLeft ? 'left' : 'right';
    const customClassName = props[direction + 'IconClassName'] || '';
    if (typeof icon === 'string') {
      return (
        <Icon
          className={getMergedClassNames([
            rootClassName + '-' + direction + '-icon',
            customClassName,
          ])}
        >
          {icon}
        </Icon>
      );
    } else {
      return (
        <div
          className={getMergedClassNames([
            rootClassName + '-' + direction + '-custom-icon',
            customClassName,
          ])}
        >
          {icon}
        </div>
      );
    }
  }, [props]);

  const getLeftIcon = useCallback(() => {
    const icon = props.leftIcon;
    if (icon) {
      return getIcon(true, icon);
    }
    return '';
  }, [props.leftIcon, getIcon]);

  const getRightIcon = useCallback(() => {
    const icon = props.rightIcon;
    if (icon) {
      return getIcon(false, icon);
    }
    return '';
  }, [props.rightIcon, getIcon]);

  const getCounter = useCallback(() => {
    return props.counter && props.counter > 0 ? (
      <Badge
        overlap='rectangular'
        className={rootClassName + '-counter'}
        color='error'
        badgeContent={props.counter}
      ></Badge>
    ) : (
      ''
    );
  }, [props.counter]);

  const getChildren = useCallback(() => {
    if (props.children && props.children.length > 0) {
      return props.children;
    } else {
      return (
        <>
          {getLeftIcon()}
          {props.label || props.children || null}
          {getRightIcon()}
          {getCounter()}
        </>
      );
    }
  }, [props.children, props.label, getLeftIcon, getRightIcon, getCounter]);

  let allProps = {
    ...props,
    variant: 'contained',
    color: 'primary',
    className: props.className
      ? props.className + ' ' + rootClassName
      : rootClassName,
    onClick: toClick,
  };
  delete allProps.leftIcon;
  delete allProps.leftIconClassName;
  delete allProps.rightIcon;
  delete allProps.rightIconClassName;

  return (
    <MuiThemeProvider theme={getButtonTheme(props.theme)}>
      <Button {...allProps}>{getChildren()}</Button>
    </MuiThemeProvider>
  );
};

export default CustomButton;